'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css3 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css4 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _css5 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css6 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 商品编辑表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _picture_wall = require('./picture_wall');

var _picture_wall2 = _interopRequireDefault(_picture_wall);

var _ship_input = require('./ship_input');

var _ship_input2 = _interopRequireDefault(_ship_input);

var _spec_price_input = require('./spec_price_input');

var _spec_price_input2 = _interopRequireDefault(_spec_price_input);

var _product_desc_editor = require('./product_desc_editor');

var _product_desc_editor2 = _interopRequireDefault(_product_desc_editor);

var _currency_input = require('./currency_input');

var _currency_input2 = _interopRequireDefault(_currency_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;

var ProductForm = _react2.default.createClass({
    displayName: 'ProductForm',
    onSubmit: function onSubmit(e) {
        var _this = this;

        e.preventDefault();
        this.props.form.validateFieldsAndScroll(function (err, values) {
            console.dir(values);
            if (!err) {
                if (_this.props.product) {
                    values.id = _this.props.product.id;
                }
                _this.props.onSubmit(values);
            }
        });
    },
    render: function render() {
        var defaultValues = {
            type: {
                id: 3,
                name: '照片书'
            },
            sku: [],
            status: 1,
            un_need_customize: 0,
            sort: 0,
            shipping_fee: 0.00
        };
        var _props = this.props,
            shippments = _props.shippments,
            _props$product = _props.product,
            product = _props$product === undefined ? defaultValues : _props$product,
            types = _props.types,
            templates = _props.templates;

        var addedSpecs = [],
            prices = product.sku.map(function (x) {
            return _extends({}, x.specification, { code: x.code, weight: x.weight, price: x.price, templates: x.templates, sku_id: x.product_sku_id });
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = product.sku[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var a = _step.value;

                var specification = a.specification;

                var _loop = function _loop(key) {
                    var foo = addedSpecs.find(function (x) {
                        return x.name == key;
                    });
                    if (!foo) {
                        addedSpecs.push({
                            name: key,
                            values: [specification[key]]
                        });
                    } else {
                        if (foo.values.indexOf(specification[key]) === -1) {
                            foo.values.push(specification[key]);
                        }
                    }
                };

                for (var key in specification) {
                    _loop(key);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var getFieldDecorator = this.props.form.getFieldDecorator;

        var formItemLayout = {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 20
            }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 6
            }
        };
        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.onSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u7C7B\u578B' }),
                getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择商品类型!' }],
                    initialValue: '' + product.type.id
                })(_react2.default.createElement(
                    _select2.default,
                    { placeholder: '\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u578B' },
                    types.map(function (type) {
                        return _react2.default.createElement(
                            Option,
                            { key: type.id, value: '' + type.id },
                            type.name
                        );
                    })
                ))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u6807\u9898' }),
                getFieldDecorator('title', {
                    rules: [{
                        required: true,
                        message: '请输入商品标题'
                    }],
                    initialValue: product.title
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u526F\u6807\u9898' }),
                getFieldDecorator('subTitle', {
                    rules: [{
                        required: true,
                        message: '请输入商品副标题'
                    }],
                    initialValue: product.subTitle
                })(_react2.default.createElement(_input2.default, null))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u6807\u7B7E' }),
                getFieldDecorator('tags', {
                    rules: [{
                        required: true,
                        message: '请输入商品标签'
                    }],
                    initialValue: product.tags
                })(_react2.default.createElement(_select2.default, { tags: true,
                    placeholder: '\u8BF7\u6DFB\u52A0\u5546\u54C1\u6807\u7B7E\uFF0C\u6309\u56DE\u8F66\u952E\u786E\u5B9A',
                    dropdownStyle: { display: 'none' }
                }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u72B6\u6001' }),
                getFieldDecorator('status', {
                    rules: [{
                        required: true,
                        message: '请选择商品状态'
                    }],
                    initialValue: product.status
                })(_react2.default.createElement(
                    RadioGroup,
                    null,
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 1 },
                        '\u4E0A\u67B6'
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 0 },
                        '\u4E0B\u67B6'
                    )
                ))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u662F\u5426\u5B9A\u5236' }),
                getFieldDecorator('un_need_customize', {
                    rules: [{
                        required: true,
                        message: '请选择是否需要定制'
                    }],
                    initialValue: product.un_need_customize
                })(_react2.default.createElement(
                    RadioGroup,
                    null,
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 0 },
                        '\u9700\u5B9A\u5236'
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 1 },
                        '\u65E0\u9700\u5B9A\u5236'
                    )
                ))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u9ED8\u8BA4\u6392\u5E8F' }),
                getFieldDecorator('sort', {
                    rules: [{
                        required: true, message: '请输入商品排序'
                    }], initialValue: product.sort })(_react2.default.createElement(_inputNumber2.default, { min: 0 })),
                _react2.default.createElement(
                    'span',
                    { className: 'ant-form-text' },
                    '\u8D8A\u5C0F\u8D8A\u9760\u524D\uFF0C\u5E8F\u53F7\u76F8\u540C\u7684\u5546\u54C1\uFF0C\u540E\u6DFB\u52A0\u7684\u5728\u524D'
                )
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u89C4\u683C\u53CA\u4EF7\u683C', required: true }),
                getFieldDecorator('spec', {
                    rules: [{ required: true, message: '请添加商品价格' }],
                    initialValue: {
                        addedSpecs: addedSpecs,
                        prices: prices
                    }
                })(_react2.default.createElement(_spec_price_input2.default, { templates: templates, showModal: this.props.showModal, params: this.props.params }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u9ED8\u8BA4\u56FE', required: true }),
                getFieldDecorator('defaultImage', {
                    rules: [{ required: true, message: '请添加默认图' }],
                    initialValue: product.defaultImage ? [product.defaultImage] : undefined
                })(_react2.default.createElement(_product_desc_editor2.default, { single: true, imageSize: '320x320' }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u9884\u89C8\u56FE', required: true }),
                getFieldDecorator('preview', {
                    rules: [{ required: true, message: '请添加预览图' }],
                    initialValue: product.preview
                })(_react2.default.createElement(_product_desc_editor2.default, { imageSize: '320x320' }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5546\u54C1\u8BE6\u60C5\u56FE', required: true }),
                getFieldDecorator('desc', {
                    rules: [{ required: true, message: '请添加详情图' }],
                    initialValue: product.desc
                })(_react2.default.createElement(_product_desc_editor2.default, { imageSize: '720xAuto' }))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', size: 'large' },
                    '\u4FDD\u5B58'
                )
            )
        );
    }
});

exports.default = _form2.default.create({
    onValuesChange: function onValuesChange(props, values) {
        return console.log(values);
    }
})(ProductForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_form.js
// module id = 1481
// module chunks = 0